import React from 'react';
import { cn } from '../utils/cn';
import ScheduleBanner from './raid2026/ScheduleBanner';
import { RAID_TOP_CTA } from './raid2026/content';
import styles from './Raid2026TopCta.module.css';

const RAID_2026_PATH = '/recruit/raid2026';
const ASSET_BASE = `${process.env.PUBLIC_URL}/assets/images/raid2026`;
const RAID_LOGO_SRC = `${ASSET_BASE}/logo_raid_simple.svg`;
const SUMMER_TEXT_SRC = `${ASSET_BASE}/text_summer_internship_2026.svg`;

export default function Raid2026TopCta({
  variant = 'section',
  className = '',
}) {
  const isSection = variant === 'section';

  const content = (
    <div
      className={cn(isSection ? styles.panel : styles.recruitPanel, className)}
    >
      <div
        className={cn(
          styles.content,
          isSection ? styles.sectionContent : styles.recruitContent
        )}
      >
        {isSection && (
          <img
            src={SUMMER_TEXT_SRC}
            alt={RAID_TOP_CTA.summerLabel}
            className={styles.summerText}
            loading="lazy"
            decoding="async"
          />
        )}
        <img
          src={RAID_LOGO_SRC}
          alt="RAID"
          className={styles.logo}
          loading="lazy"
          decoding="async"
        />
        <p className={styles.catch}>
          {RAID_TOP_CTA.catch.map(line => (
            <span key={line} className={styles.catchLine}>
              {line}
            </span>
          ))}
        </p>
        <ScheduleBanner className={styles.schedule} compact={!isSection} />
        <ul className={styles.highlights}>
          {RAID_TOP_CTA.highlights.map(item => (
            <li key={item} className={styles.highlight}>
              <span className={styles.highlightLabel}>{item}</span>
            </li>
          ))}
        </ul>
        {isSection && <p className={styles.tagline}>{RAID_TOP_CTA.tagline}</p>}
        <a href={RAID_2026_PATH} className={styles.button}>
          <span className={styles.buttonText}>
            <span className={styles.buttonLine}>
              {RAID_TOP_CTA.buttonLines[0]}
            </span>
            <span aria-hidden="true" className={styles.buttonSeparator}>
              ｜
            </span>
            <span className={styles.buttonLine}>
              <span className={styles.noBreak}>特設サイト</span>を見る
            </span>
          </span>
        </a>
      </div>
    </div>
  );

  if (!isSection) {
    return content;
  }

  return (
    <section className={styles.section}>
      <div className={styles.sectionGrid} aria-hidden="true" />
      {content}
    </section>
  );
}
